/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/wp-content/themes/eveno-site2018/assets/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__js_index__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__js_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__js_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__js_function_eveno_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__js_function_eveno_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__js_function_eveno_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__templates_style_css__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__templates_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__templates_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_index_scss__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_index_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_index_scss__);
// Import fonctions JS



// Import style parent + nouveaux styles




/***/ }),
/* 1 */
/***/ (function(module, exports) {

document.addEventListener(
  "DOMContentLoaded",
  function() {
    if (
      window.location.href.indexOf("localhost") &&
      window.location.port == 3000
    ) {
      var links = Array.from(document.getElementsByTagName("a"));
      links.forEach(function(link) {
        link.setAttribute(
          "href",
          (link.getAttribute("href") || "").replace(
            "localhost",
            "localhost:3000"
          )
        );
      });
    }
  },
  false
);


/***/ }),
/* 2 */
/***/ (function(module, exports) {

jQuery(document).ready( function() {

//RECHERCHE HEADER --------------
	jQuery( ".site-header-search" ).click(function() {
    jQuery("#head_search").toggleClass( 'head_search_show' );
	});


//MENU MOBILE --------------
	jQuery("#mobil_menu_btn").click(function() {
		jQuery("body").toggleClass("body-lock");
		jQuery(".site-header").toggleClass('nav-open');
		jQuery("#site-navigation-mobile-eveno").toggleClass('open');
		jQuery("#site-navigation").toggleClass('open');
		jQuery(".mobil_menu_overlay").toggleClass('open');
	});

	jQuery(".mobil_menu_close").click(function() {
		jQuery("#site-navigation-mobile-eveno").toggleClass('open');
		jQuery("#site-navigation").toggleClass('open');
		jQuery(".mobil_menu_overlay").toggleClass('open');
		if(jQuery("body").hasClass("body-lock")) {
			jQuery("body").removeClass("body-lock")
		}
		if(jQuery(".site-header").hasClass("nav-open")) {
			jQuery(".site-header").removeClass("nav-open")
		}

	});

	jQuery(".dropdown-toggle").click(function() {
		if(jQuery(this).hasClass("toggled-on")) {
			jQuery(this).next(".sub-menu").slideDown();
		} else {
			jQuery(this).next(".sub-menu").slideUp();
		}
	});



//IMAGE INTERACTIVE ACCUEIL --------------
	var $toutesLesInfobullesProjet = jQuery('.front_projet_infobulle');
	$toutesLesInfobullesProjet.each(function() {
		var $buttonProjet = jQuery('.front_projet_infobulle_btn', this);
		var $infoProjet = jQuery(this).next('.front_projet_infobulle_info');
		$buttonProjet.click((function () {
			var $toutesInfobullesSaufCouranteProjet = $toutesLesInfobullesProjet.not(this)
			$toutesInfobullesSaufCouranteProjet.find('.front_projet_infobulle_btn').removeClass('infobulle_activ');
			$toutesInfobullesSaufCouranteProjet.next('.front_projet_infobulle_info').removeClass('infobulle_activ');
			$buttonProjet.toggleClass('infobulle_activ');
			$infoProjet.toggleClass('infobulle_activ');
		}).bind(this));
	});


//IMAGE INTERACTIVE MAISON CONNECTEE --------------
	var $toutesLesInfobulles = jQuery('.MaisonConnectee_infobulle');
	$toutesLesInfobulles.each(function() {
		var $button = jQuery('.MaisonConnectee_infobulle_btn', this);
		var $info = jQuery(this).next('.MaisonConnecteeInfobulle');
		$button.click((function () {
			var $toutesInfobullesSaufCourante = $toutesLesInfobulles.not(this)
			$toutesInfobullesSaufCourante.find('.MaisonConnectee_infobulle_btn').removeClass('infobulle_activ');
			$toutesInfobullesSaufCourante.next('.MaisonConnecteeInfobulle').removeClass('infobulle_activ');
			$button.toggleClass('infobulle_activ');
			$info.toggleClass('infobulle_activ');
		}).bind(this));
	});


//ACCORDEON ACF --------------
	jQuery('.toggle').click(function(e) {
  	e.preventDefault();
  
    var $this = jQuery(this);

    if ($this.next().hasClass('show')) {
    	$this.parent().removeClass('accordion-active');
        $this.next().removeClass('show');
        $this.next().slideUp(350);
    } else {
        $this.parent().parent().find('li .inner').removeClass('show');
        $this.parent().parent().find('li').removeClass('accordion-active');
        $this.parent().parent().find('li .inner').slideUp(350);
        $this.next().toggleClass('show');
        $this.parent().toggleClass('accordion-active');
        $this.next().slideToggle(350);
    }

});

//ACCORDEON ACF --------------
	jQuery('.MaisonConnecteeInfobulle_btnAccordion').click(function(e) {
  	e.preventDefault();
  
    var $this = jQuery(this);
	var $maisonContent = $this.parent().siblings(".MaisonConnecteeInfobulle_txt");
	$this.parent().toggleClass('open');
	$maisonContent.toggleClass('show');
	$maisonContent.slideToggle(350);

});


//BTN SCROLL TOP --------------

var btn = jQuery('#button-to-top');

  jQuery(window).scroll(function() {
    if (jQuery(window).scrollTop() > 300) {
      btn.addClass('show');
    } else {
      btn.removeClass('show');
    }
  });

  btn.on('click', function(e) {
    e.preventDefault();
    jQuery('html, body').animate({scrollTop:0}, '300');
  });

  jQuery('.entry-slider').slick({
	autoplay: true
  });

  jQuery('.sliderHome').slick({
	autoplay: false
  });



  


});




/***/ }),
/* 3 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 4 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// bundle.js